import { FC } from 'react'

import { ISvgClass } from '../interface'

const UploadIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M6 20C5.45 20 4.97933 19.8044 4.588 19.413C4.196 19.021 4 18.55 4 18V16C4 15.7167 4.09567 15.479 4.287 15.287C4.479 15.0957 4.71667 15 5 15C5.28333 15 5.521 15.0957 5.713 15.287C5.90433 15.479 6 15.7167 6 16V18H18V16C18 15.7167 18.096 15.479 18.288 15.287C18.4793 15.0957 18.7167 15 19 15C19.2833 15 19.5207 15.0957 19.712 15.287C19.904 15.479 20 15.7167 20 16V18C20 18.55 19.8043 19.021 19.413 19.413C19.021 19.8044 18.55 20 18 20H6Z"
        fill="inherit"
      />
      <path
        d="M11.625 4.063C11.7417 4.021 11.8667 4 12 4C12.1334 4 12.2584 4.021 12.375 4.063C12.4917 4.10433 12.6 4.175 12.7 4.275L16.3 7.875C16.4834 8.05833 16.575 8.29167 16.575 8.575C16.575 8.85833 16.4834 9.09167 16.3 9.275C16.1167 9.45833 15.8794 9.55433 15.588 9.563C15.296 9.571 15.0584 9.48333 14.875 9.3L13 7.425V14.575C13 14.8583 12.9044 15.096 12.713 15.288C12.521 15.4793 12.2834 15.575 12 15.575C11.7167 15.575 11.4794 15.4793 11.288 15.288C11.096 15.096 11 14.8583 11 14.575V7.425L9.12505 9.3C8.94172 9.48333 8.70405 9.571 8.41205 9.563C8.12072 9.55433 7.88338 9.45833 7.70005 9.275C7.51672 9.09167 7.42505 8.85833 7.42505 8.575C7.42505 8.29167 7.51672 8.05833 7.70005 7.875L11.3 4.275C11.4 4.175 11.5084 4.10433 11.625 4.063Z"
        fill="inherit"
      />
    </svg>
  )
}

export default UploadIcon
